<template>
  <div>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editSoftware"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteSoftware"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editSoftware: function () {
      this.params.context.componentParent.editSoftware(this.params.data);
    },
    deleteSoftware: function () {
      this.params.context.componentParent.deleteSoftware(this.params.data);
    },
  },
};
</script>
